import { useMutation } from '@tanstack/react-query';

import { useInvalidateChannelsList } from '@/entities/channel';
import { IChannelDetailsDto, updateNumber } from '@/shared/api/channels';
import { useNotifications } from '@/shared/ui/Notifications';

export type TOldChatsAction = 'keep' | 'delete';

export const useUpdatePhone = () => {
  const invalidateChannelsList = useInvalidateChannelsList();
  const { addNotification } = useNotifications();

  const updatePhoneMutation = useMutation({
    mutationFn: ({
      channelId,
      oldChatsAction,
    }: {
      channelId: string;
      oldChatsAction: TOldChatsAction;
    }) => {
      return updateNumber(channelId, { old_chats: oldChatsAction });
    },
    onError: (error) => {
      addNotification({
        title: error.message,
        caption: error?.data?.details,
      });
    },
  });

  const updatePhone = async (
    channelId: string,
    oldChatsAction: TOldChatsAction,
    onUpdated?: (data: IChannelDetailsDto) => void
  ) => {
    return updatePhoneMutation.mutateAsync({ channelId, oldChatsAction }, {
      onSuccess: async (data) => {
        await invalidateChannelsList();
        onUpdated?.(data);
      },
    });
  };

  return {
    updatePhone,
    ...updatePhoneMutation,
  };
};
